import {React, observer, Fragment, Popover2, Tooltip2} from '@api'
import {Button, Checkbox} from '@blueprintjs/core'
import {CardSizeSlider} from '@modules/contextMenus'
import {usePresentationModeContentStore} from './'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './Footer.css'

export const Footer = observer(function Footer() {
  const {flexLayout: {activeTab: {displayName}}, hideToolbars, settings: {showNavigator}, footerPageXOfYText} = usePresentationModeContentStore()

  return (<div className={css.root} data-hide={hideToolbars && !showNavigator}>

    <span className={css.pageXofY}>
            {footerPageXOfYText}
        </span>

    <FooterToolbar/>
  </div>)
})

export const FooterToolbar = observer(function FooterToolbar() {
  const {toggleScrollbars, toggleNavigator, settings: {showScrollbars}, toggleAutoGridColumns, updateGridColumns, page, resetSize, zoomOut, zoomIn, toggleFullscreen, strings, canZoomIn, canZoomOut} = usePresentationModeContentStore()

  return (<div data-type='toolbarButtons'>
    <Tooltip2 position='top' content='Group Columns'>
      <div className={css.gridColumns}>
        {!page.autoColumns && <CardSizeSlider step={1} min={1} max={8} onChange={updateGridColumns} value={page.gridColumns ?? 4}/>}
        <Checkbox checked={page.autoColumns === true} onChange={toggleAutoGridColumns} label='Auto Columns'/>
      </div>
    </Tooltip2>
    <PrimaryIconButton icon='arrows-vertical' tooltipPosition='top' tooltipStyle='mui' tooltip={'Show Scrollbars'} active={showScrollbars} onClick={toggleScrollbars}/>
    <PrimaryIconButton icon='layout-auto' tooltipPosition='top' tooltipStyle='mui' tooltip={'Reset Size'} onClick={resetSize}/>
    <PrimaryIconButton icon='map' tooltipPosition='top' tooltipStyle='mui' tooltip={'Toggle Navigator'} onClick={toggleNavigator}/>
    {/*<PrimaryIconButton icon='move' tooltipPosition='top' tooltipStyle='mui' tooltip={'Reset Pan'} onClick={resetPan}/>*/}
    <PrimaryIconButton icon='fullscreen' tooltipPosition='top' tooltipStyle='mui' tooltip={'Toggle Fullscreen'} onClick={toggleFullscreen}/>
    <PrimaryIconButton icon='zoom-out' tooltipPosition='top' tooltipStyle='mui' tooltip={strings.zoomOut} disabled={!canZoomOut} onClick={zoomOut}/>
    <PrimaryIconButton icon='zoom-in' tooltipPosition='top' tooltipStyle='mui' tooltip={strings.zoomIn} disabled={!canZoomIn} onClick={zoomIn}/>
  </div>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/Footer.tsx